

export class Video
{
    static CATEGORIES = [
        { id : 1, title : 'Übungsausführung am Gerät' },
        { id : 2, title : 'Übungen für Zuhause / Freihantel' },
        { id : 3, title : 'Kurse' },
        { id : 4, title : 'Affirmationen / Meditationen' }
    ]
    static getTitleById( categoryId )
    {
        let title = null;

        for ( let ci = 0; ci < Video.CATEGORIES.length; ci++ )
        {
            if ( Video.CATEGORIES[ ci ].id == categoryId )
            {
                title = Video.CATEGORIES[ ci ].title;
                break;
            }
        }

        return title;
    }
};
